export const environment = {
  production: true,
  URL: 'https://live-api.vizibl.ai',
  title: 'Vizibl',
  white_label_mode: false,
  supported_dsps: new Set([
    "trade_desk_dsp",
    "beeswax_dsp",
    "amazon_dsp",
    "amazon_dsp_us",
    "amazon_dsp_eu",
    "vizibl_dsp",
  ]),
  brand_primary_color: '#e96c27',
  brand_secondary_color: '#f8a31e',
  brand_tertiary_color: '#e15e00',
  chip_color: '#e76f27',
  chip_bg_color: '#fce6c0',
  message_bg_color: '#e15e000d',
  site_logo: 'assets/img/Logo.svg',
  popup_logo: 'assets/v-icon.svg',
  welcome_img: 'assets/img/vizibl-welcome-page-logo.jpg',
  login_img: 'assets/v-icon.svg',
  js_tag: 'https://secure.datawrkz.com/',
  img_tag: 'https://secure.datawrkz.com/',
  CDP_URL: 'https://cdp-live.vizibl.ai/',
  allow_CDP: true
};
